import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ApiServices } from 'src/app/shared/services/api.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import {Subscription} from 'rxjs';
import { DataService } from 'src/app/shared/services/data.service';
import { MyProfile, MyOrder } from 'src/app/shared/interfaces/MyAccount.interface';
import { HelperService } from 'src/app/shared/services/helper.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  @ViewChild('modalRef', { static: false }) modalRef: ElementRef;

  bulkOrders: any[] = [];
  err_sku:string = ''
  restSubscription: Subscription;
  myOrders:any;
  products:any = [];
  is_hide_cost:any = null;
  errors_array:any = [];
  profileData:MyProfile;
  constructor(private apiService: ApiServices, private toastr: ToastrService, private router: Router, private dataService: DataService, public helperService: HelperService) {
    // Initialize cost hiding state - will be set properly when profile data loads
    this.is_hide_cost = null;
  }

  checkIfLoggedIn() {
    const token = localStorage.getItem('ts_vendor_access_token');
    if(token) {
    } else {
      this.toastr.error("Please login first", 'Error');
      this.router.navigateByUrl('/');
    }
  }

  ngOnInit(): void {
    this.AddMore()
    this.getUserOrders();
    this.restSubscription = this.dataService.myAccountData.asObservable().subscribe(
      myAccountData => {
        if(myAccountData) {
          this.profileData = myAccountData.my_profile;
          
          // Security: Use secure method to determine cost hiding
          this.is_hide_cost = this.helperService.shouldHideCost(this.profileData) ? "1" : null;
          
          localStorage.setItem('is_replace_logo',  myAccountData.my_profile.is_replace_logo.toString());
        } else {
          this.helperService.getMyAccountData();
        }
      }
    );
  }

  getUserOrders(){
    this.apiService.getAllUserOrder('', 6).subscribe(response => {
      if (response.status) {
        this.myOrders = this.getSortedOrders(response.data.data);
      }
    }, error => {
      this.toastr.error(error.error.message, 'Error');
    });
  }

  quantity: number = 1;
  minQuantity: number = 1;

  incrementQuantity(orderIdx) {
    const order = this.findOrder(orderIdx)
    order.quantity ++
  }

  decrementQuantity(orderIdx) {
    const order = this.findOrder(orderIdx)
    if (order.quantity > this.minQuantity) {
      order.quantity -- 
    }
  }

  getSortedOrders(orders: any){
    return orders.sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime());
  }

  redirectToOrderDetails(order_id){
    this.router.navigate(['/my-account/my-invoices'],  { queryParams: { order_id: order_id } })
  }

  transformStatus(value: number): any {
    if (value === 0) {
      return "PENDING";
    } else if (value === 1) {
      return "PROCESSING";
    } else if (value === 2) {
      return "SHIPPED";
    } else if (value === 3) {
      return "COMPLETED";
    } else {
      return "REJECTED";
    }
  }

  fetchBySKU(event: KeyboardEvent, orderidx): void {
    let error_sku_elem = document.querySelector(".sku_error");
    const inputElement = event.target as HTMLInputElement;
    let sku_loader = inputElement.closest(".bulk-order-modal-row").querySelector(".sku_loader");
    sku_loader.classList.remove("d-none");
    const sku = inputElement.value
    const order = this.findOrder(orderidx)
    order.sku = sku
    this.apiService.getProductBySKU(sku).subscribe(
      (response: any) => {
      sku_loader.classList.add("d-none");
        error_sku_elem.classList.add("d-none");
        order.imageUrl = response.data.images;
        order.price = this.is_hide_cost == null ? response.data.discounted_price : response.data.price;
        order.product_id = response.data.id;
        order.slug = response.data.slug;
        order.product_variant_id = response.data.variant_id;
        this.products.push(response.data);
        inputElement.className = `input_${order.sku}`
        inputElement.closest(".bulk-order-modal-row").querySelector(".product-description").classList.remove('hidden');
      }, err => {
        sku_loader.classList.add("d-none");
        error_sku_elem.classList.remove("d-none");
        this.err_sku = sku
        order.product_id = null;
        order.product_variant_id = null;
        inputElement.closest(".bulk-order-modal-row").querySelector(".product-description").classList.add('hidden')
      }
    );
  }

  removeFromOrders(orderIdx){
    let order_index = this.bulkOrders.findIndex(obj => obj.idx === orderIdx);
    if (order_index !== -1) {
      const deletedObject = this.bulkOrders.splice(order_index, 1);
    }
  }

  AddMore(){
    this.bulkOrders.push({ idx: this.bulkOrders.length + 1, quantity: this.minQuantity, sku: '', imageUrl: '', price: 316, product_variant_id: null, product_id: null, slug: '' });
  }

  AddToCart(event){
    this.hideErrors();
    this.errors_array = [];
    const modalElement = this.modalRef.nativeElement;
    let items:any = []
    this.bulkOrders.forEach((item)=>{
      if ( item.product_id != null && item.product_variant_id != null ) {
        items.push({
          product_id: item.product_id,
          product_variant_id: item.product_variant_id,
          quantity: item.quantity
        })
      }
    })

    if (items.length > 0) {
      this.getQuantityErrors(items);
      let quantity_errors_elm = document.querySelector(".quantity_errors") as HTMLElement;
      quantity_errors_elm.innerHTML = '';
      if(this.errors_array.length > 0) {
        quantity_errors_elm.innerHTML = `
        <div class="alert alert-danger" role="alert">
          <i class="fa fa-times-circle icon"></i> ${this.errors_array.length} product(s) require(s) your attention
        </div>`
        this.displayErrors();
      } else {
        quantity_errors_elm.innerHTML = '';

        const session_id = localStorage.getItem('session_id');
        const data = {
          session_id,
          items: items,
        };
        event.target.textContent = 'Adding ..';
        event.target.disabled = true;
        this.restSubscription = this.apiService.addToCart(data).subscribe(
          response => {
            this.toastr.success(response.message, 'Success');
            this.bulkOrders = []
            event.target.textContent = 'Add To Cart';
            event.target.disabled = false;
            this.apiService.getCart().subscribe(response => {
              if (response.status) {
                this.dataService.setCartData(response);
                this.closeModal();
                this.AddMore();
              }
          });
          }, error => {
            event.target.textContent = 'Add To Cart';
            event.target.disabled = false;
            this.toastr.error(error.error.message, 'Error');
          }
        );
      }

    } else {
      this.toastr.error("No Items to add to cart", 'Error');
    }
  }

  getQuantityErrors(items){
    items.forEach((item)=>{
      let product = this.products.find(product => product.id === item.product_id);
      if (item.quantity > product.total_quantity) {
        this.errors_array.push({
          skuBoxClass: `input_${product.sku}`,
          quantity: product.total_quantity
        })
      }
    })
  }

  displayErrors(){
    this.errors_array.forEach((errorObject=>{
      const skuInputBox = document.querySelector(`.${errorObject.skuBoxClass}`) as HTMLInputElement;
      if (skuInputBox) {
        const rowParent = skuInputBox.closest(".bulk-order-modal-row") as HTMLElement;
        const qtyBox = rowParent.querySelector(".custom-adder") as HTMLElement;
        const errElement = rowParent.querySelector(".alert-danger") as HTMLElement;

        skuInputBox.style.borderColor = "red";
        qtyBox.querySelectorAll(".qtyelem").forEach((elm=>{
          (elm as HTMLElement).style.borderColor = 'red';
        }))
        errElement.classList.remove("d-none");
        if (errorObject.quantity == 0) {
          errElement.textContent = "This item is out of stock"
        } else {
          errElement.innerHTML = `Sorry! Only <strong>${errorObject.quantity}</strong> Stock left`
        }
      }
    }))
  }

  hideErrors(){
    const bulkOrderModal = document.querySelector(".bulk-order-modal-inner") as HTMLElement;
    const inputbboxes = bulkOrderModal.querySelectorAll('input');
    const mainErrorElement = document.querySelector(".quantity_errors") as HTMLInputElement;
    mainErrorElement.innerHTML = "";
    inputbboxes.forEach((ibox)=>{
      const rowParent = ibox.closest(".bulk-order-modal-row") as HTMLElement;
      const qtyBox = rowParent.querySelector(".custom-adder") as HTMLElement;
      const errElement = rowParent.querySelector(".alert-danger") as HTMLElement;

      ibox.style.borderColor = "#d0d0d0";
      qtyBox.querySelectorAll(".qtyelem").forEach((elm=>{
        (elm as HTMLElement).style.borderColor = '#d0d0d0';
      }))
      errElement.classList.add("d-none");
    })
  }

  formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    
    return `${day}-${month}-${year}`;
  }

  private findOrder(orderIdx){
    return this.bulkOrders.find(obj => obj.idx === orderIdx);
  }

  private closeModal() {
    const modalElement = this.modalRef.nativeElement;
    modalElement.classList.remove('show');
    modalElement.style.display = 'none';
    modalElement.setAttribute('aria-hidden', 'true');
    const modalBackdrop = document.querySelector('.modal-backdrop');
    if (modalBackdrop) {
      modalBackdrop.parentNode.removeChild(modalBackdrop);
    }
    document.body.classList.remove('modal-open');
  }
}
